import React from 'react';
import { FaUserMd } from "react-icons/fa";
import { FaClinicMedical } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import { ListGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";

export default function ListItemView(props) {
    let history = useHistory();
    const prediction = props.prediction;

    const watchClinic = (clinic) => {
        history.push({
            pathname: `/clinic/${clinic.clinic_name.toLowerCase()}`,
            state: { clinic },
        });
    };

    const watchDentist = (dentist) => {
        history.push({
            pathname: `/dentists/${dentist.full_name.toLowerCase()}`,
            state: { dentist },
        });
    };

    const watchLocation = (location) => {
        console.log(prediction);
        history.push({
            pathname: `/clinics/${prediction.name.toLowerCase()}`,
            state: { prediction },
        });
    };



    switch(prediction.type) {
        case 'clinic':
            return (
                <ListGroup.Item action onClick={() => watchClinic(prediction.data)}>
                    <FaClinicMedical style={{ fill: 'blue' }} className='mr-3'/>
                    {prediction.name}
                </ListGroup.Item>
            );
        case 'dentist':
            return (
                <ListGroup.Item action onClick={() => watchDentist(prediction.data)}>
                    <FaUserMd style={{ fill: 'green' }} className='mr-3'/>
                    {prediction.name}
                </ListGroup.Item>
            );
        case 'location':
            return (
                <ListGroup.Item action onClick={() => watchLocation(prediction.data)}>
                    <FaMapMarkerAlt style={{ fill: 'red' }} className='mr-3'/>
                    {prediction.name}
                </ListGroup.Item>
            );
        default:
            return (
                <ListGroup.Item >
                    {prediction.name}
                </ListGroup.Item>
            );
      }

}

